import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-editar-confirmar',
  templateUrl: './editar-confirmar.component.html',
  styleUrls: ['./editar-confirmar.component.css']
})
export class EditarConfirmarComponent {

  @Input() titulo: string = '';
  @Input() texto: string = '';
  constructor(
    private readonly _activeModal: NgbActiveModal
  ) {}

  salir(estado: any) {
    this._activeModal.close(estado);
  }
}
